// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bei_a bhc_bk bhc_bl bhc_bo","SwipeLeftToClose--animating":"bei_b"};